<template>
  <div class="line">
    <div class="sub-title">
      <div class="flex-c rate">
        <div>{{contributionRealName}}-{{bonusRealName}}/趋势</div>
        <!--        <img  class="question"
                              src="../../../static/images/question.png" alt="">-->
        <div class="flex-c">
          <van-popover
            v-model="showTip1"
            trigger="click"
            placement="top"
          >
            <div style="padding: 10px;">1单位{{contributionRealName}}在当天累计获取的{{bonusRealName}}发放数量</div>
            <template #reference>
              <div style="height: 100%" class="flex-c">
                <img class="question"
                     src="../../../static/images/question.png" alt="">
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="flex-c filter">
        <!--      <div v-for="(item,index) in option" :key="index" :class="[index == tabIndex ? 'active' : '']" :style="styleStr"-->
        <div v-for="(item,index) in option" :key="index" :style="index == tabIndex ? styleStr : ''"
             @click="choose(index)">{{ item.text }}
        </div>
      </div>
    </div>
    <div id="line" style="width: 100%;height:222px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {Toast} from "vant";

export default {
  data() {
    return {
      option: [
        {text: "近7天"},
        {text: "近30天"},
        {text: "全部"}
      ],
      tabIndex: 0,
      chart: null,
      tipShow: false,
      seriesArr: [],
      xAxisArr: [],
      styleStr: '',
      showTip1: false
    }
  },
  props: {
    bonusRealName: '',
    contributionRealName: '',
    themeRGBColor: '',
    themeRGBAColor: '',
    themeRGBGradient: '',
    xaxis7Days: {
      type: Array,
      default: () => []
    },
    yaxis7Days: [],
    xaxis30Days: [],
    yaxis30Days: [],
    xaxisAllDays: [],
    yaxisAllDays: []
  },
  watch: {
    tabIndex(val) {
      this.initEchart();
    },
  },
  mounted() {
    this.choose(0)
    let myChart = echarts.getInstanceByDom(
      document.getElementById("line")
    );
    if (myChart == null) {
      // 如果不存在，就进行初始化
      this.initEchart();
    }
  },
  methods: {
    choose(e) {
      this.tabIndex = e
      this.styleStr = "background: " + this.themeRGBAColor + ";color: " + this.themeRGBColor + ";"

      if (e == 1) {
        this.xAxisArr = this.xaxis30Days;
        this.seriesArr = this.yaxis30Days;
      }
      if (e == 2) {
        this.xAxisArr = this.xaxisAllDays;
        this.seriesArr = this.yaxisAllDays;
      }
      if (e == 0) {
        this.xAxisArr = this.xaxis7Days;
        this.seriesArr = this.yaxis7Days;
      }
    },
    tipShowMethod() {
      // this.tipShow = true;
      alert("1单位贡献在一天内对应的积分发放数量")
    },
    initEchart() {
      this.chart = document.getElementById("line");
      var myChart = echarts.init(this.chart);
      let ratio = (30 / this.xAxisArr.length).toFixed(2) * 100;
      let that = this;
      let option = {
        tooltip: {
          alwaysShowContent: false,
          backgroundColor: 'rgb(0,0,0)',
          textStyle: {
            color: '#fff'
          },
          //鼠标hover覆盖提示框
          trigger: "axis", //坐标线提示
          formatter: function (params) {
            console.log(params)
            let rhb = '';
            let rhbSpan = '';
            let prevIndex = params[0].dataIndex - 1;
            var data = 0;
            if (prevIndex < 0) {
              rhb = '无';
              rhbSpan = `<span style="margin-left:15px;">${rhb}</span>`;
            } else {
              var prevData = 0;
              if (that.tabIndex == 0) {
                prevData = that.yaxis7Days[prevIndex];
              }
              if (that.tabIndex == 1) {
                prevData = that.yaxis30Days[prevIndex];
              }
              if (that.tabIndex == 2) {
                prevData = that.yaxisAllDays[prevIndex];
              }
              if (prevData == 0) {
                rhb = '无限大';
              } else {
                data = (params[0].data - prevData) / prevData;
                data *= 100;
                data = data.toFixed(2);
                rhb = data + '%';
              }
              if (data > 0) {
                rhbSpan = `<span style="margin-left:15px;color:${that.themeRGBColor};">+${rhb}</span>`;
              } else {
                rhbSpan = `<span style="margin-left:15px;">${rhb}</span>`;
              }
            }
            let str = `<div>${params[0].axisValueLabel}<br><span>单位${that.contributionRealName}-${that.bonusRealName}</span><span style="margin-left:15px">${params[0].data}</span><br><span>日环比</span>${rhbSpan}</div>`
            return str;
          }, //提示内容
          axisPointer: {
            type: "line",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          top: "10%",
          bottom: "10%",
          right:"25px"
        },
        xAxis: {
          type: 'category',
          // data: this.dataX,
          data: this.xAxisArr,
          boundaryGap: false, //控制日期是否在中间显示
          axisLabel: {
            show: true, //是否显示日期
            showMaxLabel: true,
            // interval: 0, //强制显示全部 // rotate: 40,//倾斜的角度
            textStyle: {
              // color: this.themeRGBColor, //日期的颜色
              color: '#ccc', //日期的颜色
              fontSize: 12 //字体的大小
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc' // x轴的颜色
            }
          }
        },
        // dataZoom: [
        //   {
        //     show: false,
        //     realtime: true,
        //     start: 100 - ratio,
        //     end: 100,
        //   },
        //   {
        //     type: "inside",
        //     realtime: false,
        //     start: 100 - ratio,
        //     end: 100,
        //     zoomOnMouseWheel: false, // 禁用滚轮
        //   },
        // ],
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              // color: this.themeRGBColor //数字的颜色
              color: '#ccc' //数字的颜色
            },
            inside: false //控制数据是否在内侧还是外侧显示
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#ccc' // 折线的颜色
            }
          }
        },
        series: [
          {
            // data: this.dataY,
            data: this.seriesArr,
            type: 'line',
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: this.themeRGBColor},
                    {offset: 0.5, color: this.themeRGBGradient},
                    {offset: 1, color: 'rgb(255,255,255)'}
                  ]
                )
              }
            },
            showSymbol: false,
            symbol: 'emptyCircle', //是否显示实心的折线圆点
            smooth: true, //让折线有弧度
            symbolSize: 7, //折线圆点的大小
            itemStyle: {
              normal: {
                color: this.themeRGBColor, //折线点的颜色
                lineStyle: {
                  color: this.themeRGBColor //折线的颜色
                },
                label: {show: false} //是否在折线点上显示数字
              }
            }
          }
        ]
      }
      myChart.setOption(option, true)

    }
  }
}
</script>

<style scoped>
.flex-c {
  display: flex;
  align-items: center;
}

.line {
  box-sizing: border-box;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  padding-top: 15px;
  padding-bottom: 20px;
}

.line .sub-title {
  padding: 0 10px;
}

.rate {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.question {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.tips {
  background: #fff;
  font-weight: normal;
  font-size: 14px;
  position: absolute;
  top: 10px;
  left: 40px;
  width: 200px;
  padding: 10px;
  box-sizing: border-box;
  /* height: 50px; */
  border: 1px solid #000;
}

.filter {
  margin-top: 10px;
}

.filter > div {
  margin-right: 15px;
  font-size: 12px;
  color: #000;
  background: rgb(247, 247, 247);
  border-radius: 40px;
  padding: 5px 10px;
}

.filter .active {
  background: rgb(234, 244, 238);
  color: rgb(97, 192, 118);
}
</style>



// WEBPACK FOOTER //
// src/component/line/line.vue